import React from 'react';
import './EmailDecisionBar.css';

interface EmailDecisionBarProps {
  onDecision: (decision: 'engage' | 'verify' | 'ignore' | 'report') => void;
  currentDecision?: 'engage' | 'verify' | 'ignore' | 'report' | null;
  disabled?: boolean;
}

const EmailDecisionBar: React.FC<EmailDecisionBarProps> = ({ 
  onDecision, 
  currentDecision, 
  disabled = false 
}) => {
  const decisions = [
    {
      key: 'engage' as const,
      label: 'Engage',
      icon: '📧',
      description: 'I would act through this email, such as replying, opening an attachment, or following a link',
      className: 'decision-engage'
    },
    {
      key: 'verify' as const,
      label: 'Verify',
      icon: '🔎',
      description: 'I would verify this through a separate trusted channel before acting',
      className: 'decision-verify'
    },
    {
      key: 'ignore' as const,
      label: 'Ignore',
      icon: '➡️',
      description: 'I would take no action on this email and would not report it',
      className: 'decision-ignore'
    },
    {
      key: 'report' as const,
      label: 'Report',
      icon: '🚩',
      description: 'I would flag this email as suspicious through my organization’s reporting process',
      className: 'decision-report'
    }
  ];

  return (
    <div className="email-decision-bar">
      <div className="decision-prompt">
        <span className="prompt-text">What would you do with this email?</span>
        {currentDecision && (
          <span className="current-decision">
            Current: {decisions.find(d => d.key === currentDecision)?.label}
          </span>
        )}
      </div>
      
      <div className="decision-buttons">
        {decisions.map(decision => (
          <button
            key={decision.key}
            className={`decision-button ${decision.className} ${
              currentDecision === decision.key ? 'selected' : ''
            }`}
            onClick={() => onDecision(decision.key)}
            disabled={disabled}
            title={decision.description}
          >
            <span className="decision-icon">{decision.icon}</span>
            <span className="decision-label">{decision.label}</span>
          </button>
        ))}
      </div>
      
      
    </div>
  );
};

export default EmailDecisionBar;
